/* OMAD'S — Inscription dans une carte « Bientôt » (sections/collection-shampoings-bientot.liquid).
   Demande de Julien du 22/10/2026 : email puis WhatsApp sur place, sans quitter la page.

   Même chemin d'écriture que les pages d'inscription (waitlist-blond-biscuit,
   waitlist-shampoing-champagne) :
     1. ligne dans `waitlist_subscriptions` (clé publique, 23505 = déjà inscrite, accepté) ;
     2. abonnement Klaviyo à la liste de la page, avec `lang` (seule propriété lue par les
        segments de langue, 10/10/2026).
   L'étape WhatsApp ne s'affiche qu'une fois les DEUX réussis : l'edge function
   `waitlist-whatsapp` refuse un numéro dont l'email n'est pas encore en base.
   Rien n'est écrit « c'est noté » tant que le serveur n'a pas répondu ok. */
(function () {
  'use strict';
  var SUPABASE_URL = 'https://eluljtthflzzsmrcoqlg.supabase.co';
  var SUPABASE_KEY = 'sb_publishable_QthosKqCipG4xedUnfPoaw_ooG-8YjW';
  var SOURCE = 'collection-shampoings-bientot';

  var qs = new URLSearchParams(window.location.search);
  var utm = {};
  ['source', 'medium', 'campaign', 'content', 'term'].forEach(function (k) { utm['utm_' + k] = qs.get('utm_' + k) || null; });
  var landing = window.location.pathname + window.location.search;
  try {
    // Mêmes UTM que la page d'inscription si la cliente est arrivée par une pub plus tôt.
    if (!utm.utm_source) {
      var saved = JSON.parse(sessionStorage.getItem('omads_wl_utm') || 'null');
      if (saved && saved.utm && saved.utm.utm_source) {
        Object.keys(utm).forEach(function (k) { utm[k] = saved.utm[k] || null; });
      }
    }
  } catch (e) { /* stockage bloqué : on garde l'URL courante */ }

  function channel() {
    if (utm.utm_source) return String(utm.utm_source).toLowerCase();
    var ref = document.referrer || '';
    if (/facebook|instagram|fb\./i.test(ref)) return 'meta';
    if (/tiktok/i.test(ref)) return 'tiktok';
    if (/google/i.test(ref)) return 'google';
    return 'site';
  }

  function post(url, headers, payload) {
    var ctrl = new AbortController();
    var timer = setTimeout(function () { ctrl.abort(); }, 20000);
    return fetch(url, { method: 'POST', headers: headers, body: JSON.stringify(payload), signal: ctrl.signal })
      .finally(function () { clearTimeout(timer); });
  }

  /* Même normalisation que la page d'inscription et le popup (dawn #460). */
  function versE164(prefix, saisie) {
    var brut = String(saisie || '').trim();
    var chiffres = brut.replace(/\D/g, '');
    var e164;
    if (brut.charAt(0) === '+') e164 = '+' + chiffres;
    else if (chiffres.indexOf('00') === 0) e164 = '+' + chiffres.slice(2);
    else e164 = '+' + prefix + chiffres.replace(/^0+/, '');
    if (!/^\+[1-9]\d{7,14}$/.test(e164)) return null;
    var nat = { '352': [6, 11], '351': [9, 9], '353': [9, 9], '33': [9, 9], '32': [8, 9], '41': [9, 9],
                '34': [9, 9], '39': [9, 11], '49': [10, 12], '43': [10, 13], '31': [9, 9], '48': [9, 9], '30': [10, 10] };
    for (var ind in nat) {
      if (e164.indexOf('+' + ind) === 0) {
        var reste = e164.length - 1 - ind.length;
        return (reste >= nat[ind][0] && reste <= nat[ind][1]) ? e164 : null;
      }
    }
    return e164;
  }

  function init(card) {
    if (card.getAttribute('data-init')) return;
    card.setAttribute('data-init', '1');
    var d = card.dataset;
    var langue = (d.language || 'fr');
    var lang = langue.slice(0, 2).toUpperCase();
    var emailForm = card.querySelector('[data-bientot-email]');
    var emailInput = emailForm.querySelector('input[type="email"]');
    var emailBtn = emailForm.querySelector('button[type="submit"]');
    var emailErr = card.querySelector('[data-bientot-err]');
    var waBox = card.querySelector('[data-bientot-wa]');
    var waStep = card.querySelector('[data-bientot-wa-step]');
    var waForm = card.querySelector('[data-bientot-wa-form]');
    var waInput = waForm.querySelector('[name="wa_number"]');
    var waBtn = waForm.querySelector('button[type="submit"]');
    var waErr = card.querySelector('[data-bientot-wa-err]');
    var waDone = card.querySelector('[data-bientot-wa-done]');
    var skip = card.querySelector('[data-bientot-skip]');
    var email = null;

    function capture(adresse) {
      return post(SUPABASE_URL + '/rest/v1/waitlist_subscriptions', {
        'Content-Type': 'application/json', apikey: SUPABASE_KEY, Authorization: 'Bearer ' + SUPABASE_KEY, Prefer: 'return=minimal'
      }, Object.assign({}, utm, {
        waitlist_name: d.waitlist, email: adresse, source: SOURCE, klaviyo_list_id: d.list,
        channel: channel(), page_url: landing, language: lang,
        referrer: document.referrer || null, user_agent: navigator.userAgent || null
      })).then(function (res) {
        if (res.ok) return;
        return res.json().catch(function () { return {}; }).then(function (err) {
          // Contrainte unique : elle était déjà inscrite à cette liste, c'est un succès.
          if (res.status === 409 && err.code === '23505') return;
          throw new Error('capture_' + res.status);
        });
      });
    }

    function subscribe(adresse) {
      var props = {
        waitlist_source: d.waitlist, signup_date: new Date().toISOString(), wl_channel: channel(),
        wl_utm_source: utm.utm_source || 'organique', wl_utm_medium: utm.utm_medium || '',
        wl_utm_campaign: utm.utm_campaign || '', wl_utm_content: utm.utm_content || '',
        wl_language: langue, wl_capture: SOURCE, lang: lang
      };
      if (d.flag) props[d.flag] = true;
      return post('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(d.company), {
        accept: 'application/json', 'content-type': 'application/json', revision: '2024-10-15'
      }, { data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Page des shampoings, carte Bientôt (' + d.waitlist + ')',
          profile: { data: { type: 'profile', attributes: { email: adresse, properties: props } } }
        },
        relationships: { list: { data: { type: 'list', id: d.list } } }
      } }).then(function (res) { if (!res.ok) throw new Error('subscribe_' + res.status); });
    }

    emailInput.addEventListener('input', function () { emailErr.hidden = true; });
    emailForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (emailBtn.disabled) return;
      emailInput.value = emailInput.value.trim().toLowerCase();
      if (!emailInput.value || !emailInput.checkValidity()) { emailInput.reportValidity(); return; }
      var adresse = emailInput.value;
      var texte = emailBtn.textContent;
      emailBtn.disabled = true; emailInput.disabled = true;
      emailBtn.textContent = d.loading;
      emailErr.hidden = true;
      Promise.all([capture(adresse), subscribe(adresse)])
        .then(function () {
          email = adresse;
          emailForm.hidden = true;
          waBox.hidden = false;
          waInput.focus({ preventScroll: true });
        })
        .catch(function (err) {
          emailErr.textContent = d.error; emailErr.hidden = false;
          emailBtn.disabled = false; emailInput.disabled = false; emailBtn.textContent = texte;
          // Pas d'email dans la console.
          console.error('[bientot-inscription] échec de l’inscription', err && err.message);
        });
    });

    function envoyerWhatsapp(numero, essai) {
      return post(SUPABASE_URL + '/functions/v1/waitlist-whatsapp', { 'Content-Type': 'application/json' },
        { waitlist: d.waitlist, email: email, whatsapp: numero, language: lang, page_url: landing })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (j) {
            if (res.ok && j.ok) return;
            // L'insertion peut avoir quelques centaines de ms de retard : un seul nouvel essai.
            if (j.error === 'not_subscribed' && essai === 0) {
              return new Promise(function (r) { setTimeout(r, 2000); }).then(function () { return envoyerWhatsapp(numero, 1); });
            }
            throw new Error(j.error || String(res.status));
          });
        });
    }

    waInput.addEventListener('input', function () { waErr.hidden = true; });
    skip.addEventListener('click', function () { waStep.hidden = true; });
    waForm.addEventListener('submit', function (e) {
      e.preventDefault();
      if (waBtn.disabled || !email) return;
      var numero = versE164(waForm.querySelector('[name="wa_prefix"]').value, waInput.value);
      if (!numero) { waErr.textContent = d.invalid; waErr.hidden = false; return; }
      var texte = waBtn.textContent;
      waBtn.disabled = true; waBtn.textContent = d.loading; waErr.hidden = true;
      envoyerWhatsapp(numero, 0)
        .then(function () { waStep.hidden = true; waDone.hidden = false; })
        .catch(function (err) {
          waErr.textContent = (err && err.message === 'bad_whatsapp') ? d.invalid : d.error;
          waErr.hidden = false;
          waBtn.disabled = false; waBtn.textContent = texte;
        });
    });
  }

  function all() { document.querySelectorAll('[data-bientot]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', all);
})();
